// React
import React, { Fragment } from 'react';
// Material-UI

// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * Sección destinada a la cabecera del contenido del contenedor
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const HeaderContenidoContenedor = ({ 
    children,
}) => {
    // Idioma
    
    // Token
    
    // Estados

    // Paginador

    // Listas
    
    // Funciones
    
    // Otros

    // Vista
    return (
        <Fragment>
            {children}
        </Fragment>
    );
};
